<template>
  <!-- Va dentro de un v-list. Sin claves configuradas en el backend no se muestra -->
  <v-list-item v-if="visible" :disabled="busy || !can_toggle" @click="toggle">
    <v-list-item-icon class="mr-3">
      <v-icon :small="dense">mdi-bell-ring-outline</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>Notificaciones push</v-list-item-title>
      <v-list-item-subtitle class="push-item__hint">{{ hint }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="can_toggle" class="my-0">
      <v-switch :input-value="enabled" :loading="busy" readonly hide-details dense class="mt-0 pt-0"></v-switch>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { pushService } from "@/libs/ws/pushService";

export default {
  name: "PushNotificationsItem",
  props: {
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      supported: pushService.isSupported(),
      needs_install: pushService.needsInstall(),
      permission: pushService.permission(),
      enabled: false,
      busy: false,
    };
  },
  computed: {
    can_toggle() {
      return this.supported && this.permission != "denied";
    },
    hint() {
      if (this.needs_install) return "Instalá la app en tu pantalla de inicio para activarlas";
      if (!this.supported) return "Este navegador no las permite";
      if (this.permission == "denied") return "Bloqueadas en la configuración del navegador";
      return this.enabled ? "Activadas en este dispositivo" : "Recibí los avisos en este dispositivo";
    },
  },
  mounted() {
    pushService
      .config()
      .then(async (response) => {
        this.visible = response.status && !!response.result.public_key;
        if (this.visible && this.supported) this.enabled = (await pushService.getSubscription()) != null;
      })
      .catch((e) => console.log(e));
  },
  methods: {
    async toggle() {
      if (this.busy) return;
      this.busy = true;
      try {
        if (this.enabled) {
          await pushService.disable();
          this.enabled = false;
        } else {
          this.enabled = await pushService.enable();
          this.permission = pushService.permission();
        }
      } catch (e) {
        console.log(e);
        this.$toast.error("No se pudieron actualizar las notificaciones.", "Error");
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style scoped>
.push-item__hint {
  white-space: normal;
}
</style>
